// `video.pixel_snap`: a clip on flat magenta snapped to a pixel grid as an alpha sprite strip (spec
// G14-mobile-game-gameplay-ad), in the worker. Live has no such job; a template's run starts it.
import { VideoPixelSnapQuote, VideoPixelSnapRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.pixel_snap"> = {
  type: "video.pixel_snap",
  label: "Pixel snap",
  source: "form",
  pair: "video.pixel_snap",
  fields: () => ({}),
  request: VideoPixelSnapRequest,
  quote: VideoPixelSnapQuote,
};
